import { Button, Image} from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import {
    TopRatedBanner,
    ImageTitle,
} from './topRatedBannerStyle';
 import LaurelSeal from '../../../assests/images/laurel_seal.webp';
import { useNavigate } from 'react-router-dom';

const TopRatedGuideBanner = ({pathname}:any) => {
  const navigate = useNavigate();
  
  return (
      <TopRatedBanner>
        <Image src={LaurelSeal}/>
        <ImageTitle>{MESSAGE.detailAwardTitle} </ImageTitle>  
        <Button className="btn-outline-success-blue" onClick={() => navigate(pathname)}>{MESSAGE.topRatedBadgeBtn}</Button>
      </TopRatedBanner>  
  )
}

export default TopRatedGuideBanner
